module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "fma1"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The Peasants’ Revolt of 1381")])]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Stephen Basdeo")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("In 1377, John Gower put his quill upon a parchment and began writing a poem entitled ‘Mirrour de l’homme’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_1",
      "id": "ch02_1"
    }
  }, [_vm._v("1")])]), _vm._v(" Something about the general state of the nation had made him uneasy—the ruling class had to be on their guard against ‘the folly of the common people … Which is too violent in nature’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_2",
      "id": "ch02_2"
    }
  }, [_vm._v("2")])]), _vm._v(" Gower saw the people as one of the raging elements—prone to violence, destructive, and unstoppable. Yet the year 1377 had, at first glance, been a rather peaceful one. Early in the year, there had been protests in Wiltshire, Surrey, and Devon—isolated incidents of unrest as some rural labourers went on strike and refused to perform their required labour services for the local landowners."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_3",
      "id": "ch02_3"
    }
  }, [_vm._v("3")])]), _vm._v(" The strikes and the protests never amounted to anything significant; it seemed as though it was business as usual. Although a new boy king, Richard II, had been crowned on 16 July that same year, the business of government would continue with the king ruling under the supervision of a set of handpicked advisors. Yet Gower’s poem might as well have been a prophecy for just four years later, in the summer of 1381, the people of England rose up and, with an army of almost 60,000, marched on London with a set of demands calling principally for the abolition of the hated poll tax and the end of serfdom.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f002-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("King Richard II. (Stephen Basdeo’s Personal Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We are indebted for our knowledge of the Peasants’ Revolt to some of the vernacular poetry which has survived in manuscript form, like ‘Tax has tenet us alle’ (‘Tax has ruined us all’). However, historians’ main sources for the study of the rebellion come from the many chroniclers who wrote about it, including Jean Froissart, Thomas Walsingham, Henry Knighton, and "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("John Gower. Other chronicles were anonymously written, such as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anonimalle Chronicle")]), _vm._v(" which was described by R.B. Dobson as ‘the single most important source for the history of the rising’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_4",
      "id": "ch02_4"
    }
  }, [_vm._v("4")])]), _vm._v(" Most of these chronicles are what we might term ‘hostile witnesses’ because they had little sympathy with the rebels and their aims. The chroniclers did not celebrate the rebels as rising up and demanding their rights, even if they disagreed with the poll tax in principle. Instead, the rebels were cast as an unruly and frightening ‘mob’ and the events of that summer of 1381 were bewailed as ‘a great and unexpected calamity not experienced by previous ages’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_5",
      "id": "ch02_5"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Context")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("But how did English society get to a state in 1381 where its people were willing to rise up and defy the law and the government and march on London? To answer this question, we must go further back into the mid-fourteenth century. In 1346, news reached Europe of some strange and tragic events occurring in China; there had been floods and earthquakes in the region in preceding years, but in 1345, many people began dying of a frightening ‘new’ disease. This disease was, to give it its scientific name "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yersinia pestis")]), _vm._v(", or what we today call the Black Death. The disease soon reached Europe. By 1347, it had reached Constantinople. Cases were found in Italy, France, Greece, and northern parts of Africa by 1348. In 1349, it reached England. Contemporary accounts are almost apocalyptic in tone, relating the disappearance of whole towns and the burying of people in mass graves."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_6",
      "id": "ch02_6"
    }
  }, [_vm._v("6")])]), _vm._v(" Its symptoms were truly horrific, as Giovanni Boccaccio revealed tumours grew in the groin and the armpits, some as large as apples, while black spots appeared all over the body."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_7",
      "id": "ch02_7"
    }
  }, [_vm._v("7")])]), _vm._v(" These symptoms were accompanied by a high fever and vomiting up of blood and the victim usually died between forty-eight hours and a week after first contracting symptoms. The death toll in Europe was truly staggering."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_8",
      "id": "ch02_8"
    }
  }, [_vm._v("8")])]), _vm._v(" With an eighty per cent mortality rate, the Black Death is estimated to have killed between seventy-five and 200 million people in Eurasia, or thirty to sixty per cent of the population."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_9",
      "id": "ch02_9"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f003-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("John of Gaunt. (Stephen Basdeo’s Personal Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The poor suffered most although there were plenty of deaths among the richer classes of society to show that the Black Death was no respecter of titles or status. Yet if a person managed to avoid contracting the disease, then they "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("might take advantage of the shortage of labour to improve their condition. English society in the fourteenth century was, at least in theory, a feudal society. At the top of the pyramid was the monarch, to whom the clergy and the nobility under him were obliged to pay taxes and/or provide services. Underneath these were the peasants—usually families who possessed the means of agricultural production and worked on small landholdings, leased from the local lord, who provided the lord with rent payments and a portion of their agricultural produce, while also keeping some produce for their subsistence. Alongside these peasants were certain free labourers who did not own any land but worked on the land for a small wage, and who can also be classed as part of the peasant class."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_10",
      "id": "ch02_10"
    }
  }, [_vm._v("10")])]), _vm._v(" At the very bottom of society were the serfs or villeins—these people were considered as the personal property of their lord who were bound to perform labour services essentially for free or for a very small wage, and serfs could neither rent nor emigrate from the village without the lord’s permission. A lord might even impose fines on the serf at will."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_11",
      "id": "ch02_11"
    }
  }, [_vm._v("11")])]), _vm._v(" A common saying was that serfs ‘owned nothing but their belly’ and their only legal protection against the whims of their lord was that they might not be killed or mutilated without a proper trial.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This social structure was well-suited for an agrarian economy but the feudal system came under increasing strain in the first half of the fourteenth century, not least because it could not easily accommodate the increasing economic and political importance of the town-based mercantile classes. After all, we have seen how after Simon de Montfort’s rebellion subsequent monarchs felt obliged to call representatives of the burgesses to parliament. As a result of the Black Death, there was a shortage of labour. The peasants and some free labourers began to demand higher wages and got them while some serfs likewise began clamouring for a wage and certain rights. The shortage of labour even extended to the church as there were not enough priests to perform basic functions such as burial rites, and even chaplains began to demand more money for performing basic liturgical services."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_12",
      "id": "ch02_12"
    }
  }, [_vm._v("12")])]), _vm._v(" Edward III’s government responded to demands for higher wages by passing the Statute of Labourers in 1351 to combat ‘the malice of servants who were idle and unwilling to serve after the pestilence without taking outrageous wages’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_13",
      "id": "ch02_13"
    }
  }, [_vm._v("13")])]), _vm._v(" It is hard for any government to successfully enforce any rules against the law of supply and demand and the successful enforcement of the Statute of Labourers was, to put it mildly, haphazard and in some areas. Particularly in the north of England, it had barely any effect at all. It was, however, enforced successfully in the south of England for some decades, and the coincidence that the Peasants’ Revolt began in areas that applied the law to its fullest extent have been remarked upon by one historian as one potential factor in the outbreak of the rebellion."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_14",
      "id": "ch02_14"
    }
  }, [_vm._v("14")])]), _vm._v(" Overall, as A.E. Levett remarked: ‘the Black Death did not, in any strictly economic sense cause the Peasants’ Revolt or the break-down of villeinage, but it gave birth, in many cases, to a smouldering feeling of discontent, which found its outlet in the rising of 1381’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_15",
      "id": "ch02_15"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were people who were only too ready to stoke these ‘smouldering feelings of discontent’. One man, in particular, was the bane of the establishment: John Ball. A mendicant priest, he travelled from town to town, village to village, preaching a "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("radical message of equality. To Ball, there were essentially two classes in society: the rich and the poor, the haves and the have-nots. The one enjoyed life and lived upon the produce of the labour of the have-nots, the poor had nothing:")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f005-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("John Ball preaching to the Commons, from Froissart’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chronicles")]), _vm._v(". (Stephen Basdeo’s Personal Collection)")])]), _vm._v(" "), _c('table', [_c('colgroup', [_c('col', {
    staticClass: "w75"
  }), _vm._v(" "), _c('col', {
    staticClass: "w25"
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "left"
  }, [_vm._v("The ryche maketh myry,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "left"
  }, [_vm._v("The rich make merry")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sed vulgus collacrematur;")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("But the common people weep;")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "left"
  }, [_vm._v("The pepulle ys wery,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "left"
  }, [_vm._v("The people are weary")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Quia ferme depopulator")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Since the land is nearly laid waste.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_16",
      "id": "ch02_16"
    }
  }, [_vm._v("16")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("After church on a Sunday, Ball would gather people around him and begin preaching his message. Froissart recorded one of his typical speeches and, in what was quite a radical message for the age, advocated for the common ownership of property and the abolition of social distinctions:")]), _vm._v(" "), _c('div', {
    staticClass: "blockq"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Good people, things cannot go right in England and never will, until goods are held in common and there are no more villeins and gentlefolk, but we are all one and the same. In what way are those whom we call lords greater masters than ourselves? How have they deserved it? Why do "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("they hold us in bondage? If we all spring from a single father and mother, Adam and Eve, how can they claim or prove that they are lords more than us, except by making us produce and grow the wealth which they spend? They are clad in velvet and camlet lined with squirrel and ermine, while we go dressed in coarse cloth. They have the wines, the spices and the good bread: we have the rye, the husks and the straw, and we drink water. They have shelter and ease in their fine manors, and we have hardship and toil, the wind and the rain in the fields. And from us must come, from our labour, the things which keep them in luxury. We are called serfs and beaten if we are slow in our service to them, yet we have no sovereign lord we can complain to, none to hear us and do us justice."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_17",
      "id": "ch02_17"
    }
  }, [_vm._v("17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Whether this speech was wholly made up by Froissart is difficult to say but it certainly encapsulated Ball’s ideology. Some historians have speculated that Ball was a Lollard—a follower of John Wycliffe (c.1320–84). Wycliffe was a religious radical who protested against the many abuses of the Roman Catholic Church, including the sale of indulgences and the practice of private confession. The Lollards also held that praying to saints was a form of idolatry and argued that the Bible should be read in English so all people could understand its message, in opposition to the Church’s official position that the Bible should be read out in Latin. Ball may have been associated with the Lollards at some point, although the only explicit connection between Ball and Wycliffe comes from a contrived confession written after Ball’s death."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_18",
      "id": "ch02_18"
    }
  }, [_vm._v("18")])]), _vm._v(" Whether he was a Lollard or not is immaterial; Ball’s own religious sentiments may indeed have corresponded with those espoused by the Lollards, yet the Lollards were concerned primarily with religious reform. It was relatively uncontroversial to criticise corruption in the church. William Langland’s allegorical poem "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Piers Plowman")]), _vm._v(" (c.1377) criticised the Roman Catholic Church on several issues and some scholars have argued that the poem is ‘proto-Protestant’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_19",
      "id": "ch02_19"
    }
  }, [_vm._v("19")])]), _vm._v(" Even Wycliffe had allies in high places; the ‘power behind the throne’ in Richard II’s days, John of Gaunt, was said to be a follower of John Wycliffe. Ball, in contrast, aimed at political and social reform. He used the teachings of the Bible to justify his egalitarian message and that made him dangerous. He first came to the authorities’ notice in 1364 when he was arrested for ‘preaching articles of faith contrary to the faith of the church to the peril of his soul and the souls of others, especially of laymen’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_20",
      "id": "ch02_20"
    }
  }, [_vm._v("20")])]), _vm._v(" Although he was eventually released, he was a thorn in the side of the religious and political establishment and further periodical spells in prison in the lead up to the revolt were to occur.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As well as disease and economic oppression, another feature of the ‘smouldering discontent’ was opposition to the government’s continuation of a costly war against France. This was the era of the Hundred Years’ War (1337–1453). Instead of seeing this as one long period of warfare, it was actually a number of intermittent conflicts between England and France fought with the aim of who should rule territory in the latter country. William the Conqueror was the Duke of Normandy and subsequent English monarchs laid claim to and ruled various territories in France. Due to various conflicts, by the war’s beginning in 1337, the only English domain which remained in "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("France was Gascony. Tensions arose when the French throne passed to Phillip, Count of Valois, who confiscated England’s remaining possessions in France, which then prompted Edward III to pursue England’s historic claims to the territory of Aquitaine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The English had some notable successes early on in the war, such as the Battle of Crecy and the capture of Calais—which English monarchs would rule until 1500—but by the 1370s, the war was going badly for the English. John of Gaunt and John de Montford led a 9,000 men strong army through a disastrous "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chavauchée")]), _vm._v(" (‘scorched earth’) campaign in 1373. A year before this, the naval Battle of La Rochelle resulted in a French victory and ended England’s naval supremacy."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_21",
      "id": "ch02_21"
    }
  }, [_vm._v("21")])]), _vm._v(" To people back in England, the entire war seemed ‘ill-managed and expensive’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_22",
      "id": "ch02_22"
    }
  }, [_vm._v("22")])]), _vm._v(" To add to the nation’s demoralisation, England’s star warrior, Edward of Woodstock, ‘The Black Prince’, was suffering from a debilitating illness and died in 1376 and a year later King Edward III also died. The throne of England, therefore, passed to the Black Prince’s son, the ten-year-old Richard of Bordeaux, who was crowned on 16 July 1377 as Richard II. Parliament decided that a regency should be established until Richard reached the age of majority—this was common when the ruling monarch was deemed too young to shoulder the burden of running the state. Richard’s uncle, John of Gaunt, was widely disliked among the ruling elites. One of the wealthiest men in England, his hold over the government had increased since the early 1370s because of Edward III’s old age and the Black Prince’s death. Parliament wanted Gaunt to be involved as little as possible with the business of government, fearing that he might attempt to overthrow the boy king and place himself on the throne. Nevertheless, in spite of parliament’s efforts to exclude him from high office, he still retained a lot of influence over the king himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gaunt was also unpopular with the people at large because he advocated the continuance of the war and seemed to be demanding ever more men and money to be given to him for the cause. In view of the war’s increasing cost, in 1377, it was Gaunt who convinced parliament to levy the first-ever poll tax in England: every person over the age of fourteen would be required to pay one groat (4d) in tax. Gaunt hardly endeared himself to the population when he initiated this tax, and further to this there was the ill-fated expedition of 5,000 men the following year where, under Gaunt’s command, the English laid siege to St Malo but suffered a humiliating defeat. It seemed as though ever more men and increasing amounts of money were needed for this ill-managed war. The revenue from the first poll tax earned the government £22,000; the ill-fated Breton campaign had cost the government £5,000. And the government was planning another attack on France the year following Gaunt’s disastrous expedition."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_23",
      "id": "ch02_23"
    }
  }, [_vm._v("23")])]), _vm._v(" Thus, in their wisdom, in 1379, the government decided that a fresh poll tax was needed to meet the nation’s military cost. This time somewhat fairer, the tax was graduated according to a person’s status, meaning that the rich paid more than the poor, and only persons over sixteen years old had to pay it. A franklin in Wath, Yorkshire, for example, was liable to pay 40d; one Roger Bacon and his wife Emma had to pay 12d; Robert Hesilheued and Margaret his wife were required to cough up 6d, and the single woman Johanna Bythewater paid just 4d."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_24",
      "id": "ch02_24"
    }
  }, [_vm._v("24")])]), _vm._v(" Vagrants and the destitute had always been exempt from poll taxes and this time was no different."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_25",
      "id": "ch02_25"
    }
  }, [_vm._v("25")])]), _vm._v(" Yet even this tax could not satisfy the government’s needs and the total returns were much lower than in 1377. The people "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("were partly to blame for this—medieval people up and down the country were very good at finding ways to avoid paying their taxes, while there is some evidence to suggest that during the collection of the first poll tax, some tax gatherers themselves did not bother to collect taxes from some poorer people in spite of the fact that, technically according to the law, they should have been able to pay."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_26",
      "id": "ch02_26"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With low returns and tax evasion rife, in Northampton on 5 November 1380, parliament decided that another poll tax would be collected. This decision came in the wake of a particularly bad harvest and a harsh winter, and the government now meant business. The age of eligibility was lowered to fifteen and the tax applied to all men and women whether they were single or married. All would have to pay a tax of 12d. There would be very few exemptions; not even those craftsmen and labourers who worked for the church would be exempt, as they were previously. And it would have to be collected quickly: two-thirds of the money was to be collected by the end of January 1381 and the rest had to be paid by June the same year. To give the government the benefit of the doubt, we should note that the government expected each town and parish to forward to the exchequer a set amount, and their advice was that this generally worked out at a flat fee of 12d per head."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_27",
      "id": "ch02_27"
    }
  }, [_vm._v("27")])]), _vm._v(" How it was to be collected, however, was left up to the discretion of tax collectors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The winter was harsh and the harvest had been bad. The war was being lost and it seemed as though it was too expensive to pursue. Grievances about poll tax emanated from the lips of the poor, the peasants and tradesmen. In light of this, the authorities deemed it prudent to imprison the troublesome priest John Ball once again in April 1381. Even parliament was suspicious of the ends to which the tax was going to be used, and some in parliament viewed this third and latest tax as simply another ruse for John of Gaunt to fill his coffers. The government had calculated that £110,000 needed to be raised for the nation’s defence. The Archbishop and Chancellor of the Exchequer, Simon Sudbury, had requested £160,000 and the justification for the extra amount seemed rather flimsy. At any rate, parliament granted the government’s request for a new tax, even though its representatives knew that it would be extremely unpopular with people. Parliament even exempted members of their own class from the responsibility of collecting it, whereas before its members would have served as collectors—an important condition which parliament attached to the granting of the poll tax was that ‘the knights, citizens, and burgesses who have come to this present parliament are by no means to be made collectors or controllers of the aforesaid sums’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_28",
      "id": "ch02_28"
    }
  }, [_vm._v("28")])]), _vm._v(" The responsibility for collecting the new tax was therefore delegated to an assortment of bailiffs, constables, mayors, and two men from each village and township who had been specifically appointed to the position of tax gatherer because of their local knowledge.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Spark")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("People still managed to evade the new tax and the government was exasperated with the situation. Special commissioners were appointed by the government to travel to each village and township and investigate why the revenue collected was different "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("to the calculations which the government had expected. One such commissioner was Thomas de Bamptoun (called John in some accounts). On 30 May, Bamptoun travelled to Brentwood in Essex. He summoned before him all the villagers of Fobbing, Corringham, and Standford-le-Hope and demanded that they all pay the tax immediately. The villagers, who had chosen as their spokesman one Thomas Baker, declared that they would not be paying because they had already paid the tax and could prove it by showing him receipts. Bamptoun had two armed soldiers with him and ordered the arrest of those who refused to pay but the crowd grew angry and attempts to arrest those who refused to pay up were futile—the crowd protected the ringleaders and refused to let them be arrested. Bamptoun and his men hastily withdrew from Brentwood and went back to London with their tails between their legs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The revolt had started.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The people of Fobbing, Corringham, and Standford-le-Hope sent messengers to the surrounding towns and villages urging people to rise up against their lords and the poll tax collectors. News of what happened at Brentwood travelled fast throughout Hertfordshire, Sussex, Essex, and Kent. The rebels were not illiterate brutes but included people who could read and write. These people were used, as Steven Justice points out, to write messages on parchment urging people to rise up. These written messages which the rebels made use of were called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("escrowez")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("schedulae")]), _vm._v("—according to Steven Justice the closest equivalent we have in our own time is broadside: a single sheet of paper containing urgent public announcements or news. These broadsides were then mounted in public spaces in nearby villages and towns."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_29",
      "id": "ch02_29"
    }
  }, [_vm._v("29")])]), _vm._v(" Some of the richer townsfolk who decided against joining in the rebellion had their houses destroyed, and one man in Maidstone was even beheaded for his refusal."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_30",
      "id": "ch02_30"
    }
  }, [_vm._v("30")])]), _vm._v(" The rebels’ next act on 6 June was to rescue a serf named Robert Belling from Rochester gaol, who had been imprisoned there at the behest of Sir Simon de Burley, one of the Knights of the King’s Household."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_31",
      "id": "ch02_31"
    }
  }, [_vm._v("31")])]), _vm._v(" Although the rebels laid siege to the castle for a day and a half, the constable decided that it would just be easier to set the man free and open the castle. The rebels then entered and freed all of the prisoners.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By 7 June, the rebels of Kent appointed a man named Wat Tyler as their leader. Little is known of Wat Tyler’s early life, where he was born, who his parents were, or even whether he had any children. Some sources suggest that he may have been a soldier who had served in France during the wars and was appointed because of his experience in leading soldiers. Other sources allege that he was a blacksmith, or that his surname, Tyler, indicated his trade — that he was a tiler. Another source, written much later by John Stow, titled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Summarie of English Chronicles")]), _vm._v(" (1566), alleges that Tyler—who was renamed John Tiler in this source—was moved to lead the revolt after a tax collector visited Tyler’s home. The tax collector, not believing that Tyler’s daughter was a minor, attempted to indecently search her. In the words of another later source that repeated these claims, the tax collector ‘pulled up his daughter’s cloaths [sic] to see if she was arrived at the age of puberty’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_32",
      "id": "ch02_32"
    }
  }, [_vm._v("32")])]), _vm._v(" According to Stow’s account, this enraged Tyler who, being a blacksmith, took his hammer and smote the tax collector, killing him stone dead. This particular narrative was repeated in many later novels, plays, and history books during the eighteenth and nineteenth centuries, to the point where people viewed "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("it as a historical fact. However, there are no primary sources that relate this occurrence and it almost certainly never happened.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f010-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The rebels await an audience with Richard II, from Froissart’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chronicles")]), _vm._v(". (Stephen Basdeo’s Personal Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prior to June, John Ball had once again found himself on the wrong side of the Church authorities and he was currently imprisoned in Maidstone. Under Wat Tyler’s command, the rebels besieged Maidstone gaol, freed all of the prisoners, including John Ball. Yet it wasn’t men who had all the fun. Sylvia Federico has also uncovered the stories of a number of women who took a leading role in the rebellion."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_33",
      "id": "ch02_33"
    }
  }, [_vm._v("33")])]), _vm._v(" A woman named Julia Pouchere came to Maidstone and by all accounts took a leading role in laying siege to the gaol."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_34",
      "id": "ch02_34"
    }
  }, [_vm._v("34")])]), _vm._v(" John Ball being freed, the rebels asked him to accompany them on their planned march to London, where they would take their grievances directly to the king. They also promised to appoint Ball as the Archbishop. The fact that the rebels thought to free John Ball testifies to the man’s fame and popularity—he had of course first been arrested in 1364 and the message which he preached must surely "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("have been popular with people who had seen their rights eroded, their wages stagnate, and their income decimated with three successive poll taxes. After Ball’s liberation from Maidstone gaol, the rebels began their march on Canterbury on 9 June. Four thousand men entered the city on the following day, and many of them attended Mass at St Thomas’ Mother Church. The castle and the Archbishop of Canterbury’s palace were then ransacked. Afterwards, the Mayor, bailiffs, and the common people of the town were then assembled before the rebels. Those present were asked to swear ‘to be faithful to King Richard and the loyal commons of England’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_35",
      "id": "ch02_35"
    }
  }, [_vm._v("35")])]), _vm._v(" Still the rebels, it will be noted, found no fault with the king. They merely resolved ‘to get rid of all lords, archbishops, bishops, abbots and priors, as well as most of the monks and canons’. How convenient, then, that the rebels had Ball with them—a man of God from among their own ranks whom they could elevate to the position of an archbishop."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_36",
      "id": "ch02_36"
    }
  }, [_vm._v("36")])]), _vm._v(" Indeed, the rebels were not a mindless mob. As we shall see shortly, they had a well-thought-out list of demands. As one of the rebels’ demands was an end to serfdom, while the mob was at Canterbury, they entered the houses of several local nobles and destroyed any documents that might confirm whether a person was a bondman or not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The next day, 11 June, Tyler and the people began their march from Canterbury to London. On the way, they came across twelve lawyers and twelve knights, accosting them and forcing them to swear allegiance to their cause upon pain of death. Also along the way, they ransacked the houses of several nobles. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anonimalle Chronicle")]), _vm._v(" records that they did the most damage to the house of Thomas de Heseldene, one of Gaunt’s men, by razing his house to the ground and stealing his livestock."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_37",
      "id": "ch02_37"
    }
  }, [_vm._v("37")])]), _vm._v(" By this time the king had heard of the uprising, and on their way to London on 11 June the rebels were met by some of the king’s messengers who asked the rebels why they were acting thus. The rebels replied that they were rising up ‘to save [the King] and to destroy traitors to him and his kingdom’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_38",
      "id": "ch02_38"
    }
  }, [_vm._v("38")])]), _vm._v(" The king’s messengers then informed the rebels that Richard would meet with them and hear their demands. It is also said by Froissart—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("only")]), _vm._v(" by Froissart, it should be noted—that the Queen Mother, Joan of Kent (1328–85), the wife of Edward the Black Prince, was returning from a pilgrimage to Canterbury and ran into the rebels. Froissart records that the insurgents treated her in a very disrespectful manner:")]), _vm._v(" "), _c('div', {
    staticClass: "blockq"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("She was in great jeopardy to have been lost, for these people came to her chare [sic] and dealt rudely with her, whereof the good lady was in great doubt lest they would have done some villainy to her or to her damosels. Howbeit, God kept her, and she came in one day from Canterbury to London, for she never durst tarry by the way."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_39",
      "id": "ch02_39"
    }
  }, [_vm._v("39")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This ‘fact’ deserves to be taken with a pinch of salt; given the fact that throughout the whole affair the rebels repeatedly emphasised their loyalty to the king, it seems unlikely that they would have ‘dealt rudely’ with the queen mother.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The following day, the rebels from Kent arrived at Blackheath. According to Thomas Walsingham, it was here that John Ball addressed a sermon to the assembled multitude with the famous theme, ‘whan Adam dalf and Eve span, Wo was thanne a gentilman?’"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_40",
      "id": "ch02_40"
    }
  }, [_vm._v("40")])]), _vm._v(" Meantime, the rebels from Essex made camp at Mile End, while more "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("rebels were arriving from Surrey, Sussex, Norfolk, Cambridgeshire, Buckinghamshire, and Hertfordshire. It is estimated that the number of the rebels now amounted to 50,000 people according to some accounts, with 30,000 alone being in Wat Tyler’s army.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The country was erupting in violence. While the rebels from Kent and the surrounding counties were beginning their march upon London, riots occurred in other towns and cities. At Cambridge on 14 June, rebels invaded the university and ransacked the library. Yet they were not, as might be supposed, an unhinged mob who sought only to destroy. They had a great respect for learning and the university’s library containing rare Bibles, prayer books, chronicles, and manuscripts from time immemorial were spared. The rebels only destroyed court rolls and muniments (title deeds that proved a lord’s right to a certain patch of land or an estate)."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_41",
      "id": "ch02_41"
    }
  }, [_vm._v("41")])]), _vm._v(" This was a well-thought-out strategy; in fourteenth century court cases, if a dispute arose between a lord and a tenant, the lord had to be able to give evidence that the tenant owed him a particular service or rent-in-kind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At this point, on 13 June, the king, who only had 520 soldiers with him, retreated to the Tower of London along with Sudbury and Robert Hales, the Lord High Treasurer. The high walls and heavy fortifications of the Tower would, of course, have provided some protection against any sudden turn in the rebels’ disposition toward him. Upon hearing that the king had retreated to the Tower, Wat Tyler sent a message to the king, asking to meet him at Rotherhithe. The king agreed to this, and by the afternoon he boarded a barge and travelled the short way down the Thames to meet Tyler and the "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("rebels. This was quite a brave act for the young king, as the sight of the rebels lining the banks of the Thames while he was sailing down it to meet with Tyler must have been a daunting one. Accompanying the now fourteen-year-old king was Sudbury and Hales. It might have been better for the young king to go alone, all things considered, for when the people saw the two hated officials in the barge with Richard the crowd became incensed, calling them traitors. It was these two men, after all, who had first proposed the 1381 poll tax. Perhaps wisely considering the circumstances, Richard decided not to disembark and after ten minutes he decided to return to the Tower.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f012-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The rebels execute the Archbishop of Canterbury, from Froissart’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chronicles")]), _vm._v(". (Stephen Basdeo’s Personal Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the afternoon of the same day, rebels from Kent arrived at the Southwark entrance to London. The rebels enjoyed a significant degree of support from the residents of London as well. After all, those in London were also liable to pay the poll tax, just as those from the country had been. Thus, some of the rebels’ supporters from inside the city lowered the drawbridge and opened the gates to allow them to enter. The rebels’ hatred of John of Gaunt meant that one of their first acts, when they managed to get inside the walls, was to rob and then set fire to Gaunt’s palace at the Savoy. According to Froissart, the sacking of Gaunt’s residence was done under the instruction and supervision of Wat Tyler, John Ball, and Jack Straw."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_42",
      "id": "ch02_42"
    }
  }, [_vm._v("42")])]), _vm._v(" It is more likely, however, that the destruction of Gaunt’s palace was carried out at the instigation of John Farringdon, a rebel from Essex. This was the man who, on the same evening, led the rebels into the Hospitallers’ Priory at Clerkenwell. There they beheaded the master of the order, and burned the building and several of the surrounding edifices to the ground."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_43",
      "id": "ch02_43"
    }
  }, [_vm._v("43")])]), _vm._v(" The rebels of course were not saints and sadly, if Froissart and other chroniclers are to be believed, some of the rebels did turn nasty, for it is reported in Froissart’s account that some of them began attacking the houses of the Lombards, an immigrant community in London."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_44",
      "id": "ch02_44"
    }
  }, [_vm._v("44")])]), _vm._v(" Some of the other rebels also used the disturbances to enrich themselves and settle scores against their neighbours at the same time. This is what we see, for example, in the records of the Court of Common Pleas: Joan Aleyn stole 2s 6d from her neighbour; Agnes Stevenage burgled the house of John Brode, an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("escheator")]), _vm._v(" in Kent, although an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("escheator")]), _vm._v(" was a royal official charged with, among other things, collecting taxes, so perhaps her actions were way of her getting revenge on the government "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" enriching herself."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_45",
      "id": "ch02_45"
    }
  }, [_vm._v("45")])]), _vm._v(" Furthering the rebels’ aims while taking a little for herself is also what a woman named Johanna did while Gaunt’s palace was being attacked. Johanna took a chest containing over £1000 from Gaunt’s palace, then took a boat to Southwark where she divided the spoils between herself and her friends."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_46",
      "id": "ch02_46"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although Tyler had wanted to meet with the king on the same morning, it will be remembered that the young king, perhaps wisely though not very bravely, sped away back to the Tower in his barge. It was not until the following day around 8.00 am that Tyler came face to face with the boy king at Mile End. Knighton says that most of the king’s knights left him to face the mob alone, ‘[having] completely lost their courage and showed, sad to say, no spirit whatsoever; they seemed to be struck by womanly fears and dared not leave but stayed within the Tower’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_47",
      "id": "ch02_47"
    }
  }, [_vm._v("47")])]), _vm._v(" It was here that Wat Tyler put the rebels’ reasonable grievances before the king: the abolition of the poll tax, end of all feudal services, the freedom to buy and sell goods (serfs at this time could not freely sell the surplus produce of their labour in the marketplace), and a general pardon for "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("all offences that had been committed during the rebellion. Wat Tyler also accused those responsible for the poll tax as being guilty of corruption and he demanded that they should be executed. The king agreed to the first set of demands by granting a charter confirming them."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_48",
      "id": "ch02_48"
    }
  }, [_vm._v("48")])]), _vm._v(" However, Richard said that his people could be confident that, if any of his advisors were guilty of corruption then they would be punished to the full extent of the law. The granting of the charter, and Richard’s assurances, appeared to placate much of the mob for the moment and many rebels agreed to withdraw.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gilbert á Beckett once joked: ‘Whether or no Wat suspected the worthlessness of charters, which might be sworn to one day and treated as waste paper the next, he refused to be satisfied’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_49",
      "id": "ch02_49"
    }
  }, [_vm._v("49")])]), _vm._v(" Although writing with his tongue firmly in his cheek, Beckett was right: the rebels, while they respected the king, had little trust in the government who they suspected would, in a heartbeat, renege on the pledges enshrined in the charter. Tyler, Straw, Ball and quite a few of the rebels must have suspected this, and while many rebels returned home, Tyler decamped to Smithfield with about 30,000 of his men."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_50",
      "id": "ch02_50"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While Tyler was with the king at Mile End, a contingent of rebels remained near the Tower. Led by John Starling, this group gained admittance to the castle, and there they laid hands upon Sudbury. They dragged him to Tower Hill where he was beheaded. His head was then placed upon a spike, and paraded through the city of London. It is here also that Robert Hales, the King’s Treasurer, and John Legge (who along with Sudbury was instrumental in bringing about the hated tax) met their ends in a similar manner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the following day, the king expressed a desire to meet with Wat Tyler again at Smithfield. The king arrived with a number of armed retainers, and inquired why, when the charters had been granted, the rebels were still in London. According to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eulogium Historiarum")]), _vm._v(", when the king arrived Tyler refused to dismount from his horse or remove his cap, and according to some accounts he spoke to the sovereign in a surly manner."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_51",
      "id": "ch02_51"
    }
  }, [_vm._v("51")])]), _vm._v(" Tyler reiterated his previous demands to the king, as well as adding several new ones, some of which were undoubtedly inspired by the teachings of John Ball: the end of tithes, the abolition of bishops, the redistribution of wealth, equality before the law, and the freedom to kill animals in the forest. At this point, Wat Tyler noticed that one of the king’s squires was bearing a dagger, and Tyler demanded that the dagger be given to him. The king ordered his squire to do as Tyler commanded. Tyler then demanded the sword that the squire was carrying. It is at that this point that the villain of the story emerges from the shadows. William Walworth (d. 1385), the Mayor of London, had also arrived at Smithfield with several armed men. Upon seeing that Tyler had not been giving due deference to the king, Walworth began to quarrel with Tyler, at which Walworth exclaimed:")]), _vm._v(" "), _c('div', {
    staticClass: "blockq"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Thou false stinking knave, shalt thou speak thus in the presence of the King my natural Lord? I commit never to live, without thou shalt dearly abye it."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_52",
      "id": "ch02_52"
    }
  }, [_vm._v("52")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Walworth then drew forth his dagger and struck Tyler in the neck, causing him to fall from his horse. The next instant, one of the king’s squires, John Cavendish (or Ralph Standish in some accounts), alighted from his horse and stabbed Tyler in the stomach."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_53",
      "id": "ch02_53"
    }
  }, [_vm._v("53")])]), _vm._v(" This was the fatal blow, and Tyler did not recover from this murderous act."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_54",
      "id": "ch02_54"
    }
  }, [_vm._v("54")])]), _vm._v(" The rebels "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("grew angry that Walworth had killed their leader, crying, ‘Ah, our captain is slain, let us go and slay them all.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_55",
      "id": "ch02_55"
    }
  }, [_vm._v("55")])]), _vm._v(" Perhaps sensing a bloodbath, the King addressed the rebels:")]), _vm._v(" "), _c('div', {
    staticClass: "blockq"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("‘Sirs, what aileth you? Ye shall have no captain but me: I am your King: be all in peace’. And so the most part of the people that heard the King speak and saw him among them, were shamefast and began to wax peaceable and to depart."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_56",
      "id": "ch02_56"
    }
  }, [_vm._v("56")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The king then turned to his advisors and asked them what should be done with the remaining rebels. Richard was advised to allow them to withdraw by Walworth, with a proviso that they should pursue them afterwards. Afterwards, Tyler’s body was decapitated in Smithfield and his head was placed upon a spike, carried through London, and set atop London Bridge as a warning to others who might dare defy the established order.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Predictably, Richard annulled all of the charters that he had granted previously. His army pursued some of the rebels on their way out of London, and a battle was fought between the king’s soldiers and the Essex men on 28 June. On that day, approximately 500 of the rebels were killed. One by one, former leading figures in the rebellion were hunted down. Thomas Baker and his comrades from Fobbing were executed at Chelmsford. John Ball was arrested in Coventry and taken to St Albans where he "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("suffered the horrific punishment of being hung, drawn, and quartered on 15 July. The rebel movement, without its key central figures, effectively collapsed. Further afield, in places such as Yorkshire, Lincolnshire, and Suffolk, other rebel leaders were hunted down and dealt with in the manner of the times.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f015-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The death of Wat Tyler, from Froissart’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chronicles")]), _vm._v(". (Stephen Basdeo’s Personal Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jack Straw was also taken afterwards. He was also sentenced to a traitor’s death but his case is interesting because we have his supposed last speech. The gist of this, when loosely translated into English, is as follows:")]), _vm._v(" "), _c('div', {
    staticClass: "blockq"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("We would have murdered all the knights, esquires, and gentlemen in his retinue and to have led the king royally used, up and down, that with the sight of him, so that the common people would have followed us, and when we had got together an innumerable multitude, we would have suddenly put to death in every country, the Lords and masters of the common people, who might have resisted us, and we would have destroyed the Knights of Saint John, lastly we would have killed the king himself, and all bishops, monks, canons, parsons. We would only have spared the beggar friars in order that they might administer the sacraments. We would have made kings: Wat Tyler in Kent, and we would have appointed other kings in other counties."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_57",
      "id": "ch02_57"
    }
  }, [_vm._v("57")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("After this short speech, Straw was executed and his head was placed on top of London Bridge alongside that of his fellow rebel leader, Wat Tyler. It is likely that the other parts of Straw’s body, as well as Tyler and Ball’s, were sent to be displayed in public spaces in other cities, although none of the accounts of the revolt tell us where.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet the young king would eventually receive his comeuppance. Perhaps the manner in which he dealt with the rebels made him paranoid about any perceived threats to his authority. Many nobles were unhappy with the way in which Richard went on to abuse his power later in life, so much so that, in 1388, a group of nobles sought to impeach the king’s favourite advisors in an attempt to curb what was widely perceived as an increasingly tyrannical reign. The nobles who challenged Richard were led by none other than John of Gaunt’s son, Henry Bolingbroke (1367–1413). In response to the nobles’ challenging of his power, at a parliament called in Shrewsbury in 1399, Richard effectively declared himself above the law, and placed all parliamentary power into the hands of twelve Lords and six commoners who, needless to say, were loyal to him. He was now to all intents and purposes an absolute ruler.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Enough was enough. In 1399, Bolingbroke, whose father’s estate had been seized by Richard upon his death earlier in the year, returned to England from France with a view to regaining his lands and titles. Although Bolingbroke insisted that this was all that he wanted to do, the small band of followers that arrived with him when he first landed at Yorkshire soon swelled. Richard at this moment was in Ireland, so as Bolingbroke and his army progressed through England, they encountered little resistance. When Richard returned to England, upon seeing that Bolingbroke had the support of the nobles and that, militarily, he held the upper hand, he surrendered to Henry at Flint Castle. From there, Richard was taken to Pontefract Castle and imprisoned. The circumstances of his "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("death are very unclear, although it appears to be generally agreed amongst historians that Richard simply starved to death in the vaults of the castle."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_58",
      "id": "ch02_58"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are many ‘what ifs’ in history, and, in spite of Wat Tyler’s death, had the king kept his word, and not annulled the charters granted to the bondmen, his reign might have gone down as an example of good government. But it was not to be.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Legacy of the Peasants’ Revolt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("The Peasants’ Revolt itself achieved very little. The rebels’ demands remained, as we have seen, unrealised. The king reneged on his promises after Tyler’s execution at Smithfield. The Peasants’ Revolt did not end feudalism but was rather a symptom of the strain that the feudal system was undergoing. Even at the beginning of the century increasing numbers of people were working for wages and, in spite of the Statute of Labourers, both free men and serfs were increasingly able to demand wages for service. The Black Death was a shock to the feudal system and precipitated its decline even further. Even after the Black Death and the Peasants’ Revolt, in villages where a manorial lord was unwilling to pay wages and insisted upon imposing his feudal rights, serfs simply absconded to the cities where they could work for a wage. Yet the revolt was important because it was the first time that the people themselves had risen up against the ruling class. There had been revolts before, of course. The Barons’ Rebellion which led to King John signing Magna Carta in 1215, or Simon de Montfort’s Rebellion in 1265 immediately spring to mind. But these were rebellions led by disaffected noblemen. Not so with the Peasants’ Revolt—this truly was a revolt by the people.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f017-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Robert Southey, author of Wat Tyler: A Dramatic Poem (1794). (Stephen Basdeo’s Personal Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fact that in 1381 the people attempted to take power to themselves is probably why Wat Tyler and the events of that year would be remembered throughout succeeding ages, being an inspiration to revolutionaries, Chartists, and socialists."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_59",
      "id": "ch02_59"
    }
  }, [_vm._v("59")])]), _vm._v(" Thomas Paine’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Common Sense")]), _vm._v(" (1776)—a book which advocated independence for the Thirteen American Colonies from Great Britain—heaped praise on Tyler and argued that his actions merited a monument at Smithfield:")]), _vm._v(" "), _c('div', {
    staticClass: "blockq"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("Tyler appears to have been an intrepid and disinterested man, with respect to himself. All his proposals made to Richard, were on a more just and public ground, than those which had been made to [King] John by the Barons; and notwithstanding the sycophancy of historians, and men like Mr. Burke, who seek to gloss over a base action of the Court by traducing Tyler, his fame will outlive their falsehood. If the Barons merited a monument at Runnymede, Tyler merits one in Smithfield."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_60",
      "id": "ch02_60"
    }
  }, [_vm._v("60")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("At the beginning of the French Revolution in 1789, many radicals in Britain were inspired by the French who had finally, it seemed, put the final nail in feudalism’s coffin. They wished for a similar revolution to take place in England. Among them was Robert Southey who wrote, in 1794, a short poem titled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wat Tyler")]), _vm._v(", in which the politics of Britain in the 1790s were superimposed onto England in 1381. In this poem, Wat is a freedom fighter, taking up the country’s cause against the unjust taxes that have been levied to finance Richard II’s wars (with a message for his own day regarding the war against Revolutionary France):")]), _vm._v(" "), _c('div', {
    staticClass: "blockq"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Think you we do not feel the wrongs we suffer?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The hour of retribution is at hand,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("And tyrants tremble – mark me, King of England."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_61",
      "id": "ch02_61"
    }
  }, [_vm._v("61")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("There appears to have been a trend at this point for radicals appropriating figures from England’s medieval past: one year after Southey was writing there appeared Joseph Ritson’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Robin Hood: A Collection of All the Ancient Poems, Songs, and Ballads")]), _vm._v(" (1795) which portrayed the outlaw as a medieval Thomas Paine."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_62",
      "id": "ch02_62"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps the greatest fictional account of Wat Tyler’s life comes from Pierce Egan the Younger’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wat Tyler, or, the Rebellion of 1381")]), _vm._v(" (1841). In this novel, Tyler is truly allowed to live up to his potential. Thomas Paine held him up as a working-class hero, while Robert Southey envisioned him as a man who fought for ‘Liberty! Liberty!’ Circumstances had changed when Egan was writing, and Britain saw the emergence of Chartism between 1838 and 1858. It was a working-class political reform movement which sought to establish a People’s Charter: A vote for every man twenty-one years of age, of sound mind, and not undergoing punishment for a crime; the Secret Ballot; no Property Qualification for MPs; Payment of MPs, thus enabling an honest working man to serve a constituency; equally-sized constituencies, securing the same amount of representation for the same number of electors, instead of allowing small constituencies to swamp the votes of large ones; and annual parliamentary elections.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Egan’s novel, Tyler is a man who fights for a medieval form of a People’s Charter (the Chartists even had a Wat Tyler Brigade). Egan borrows the Saxon versus Norman theme from Walter Scott’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ivanhoe")]), _vm._v(" (1819). The Normans represent the nineteenth century political establishment, while Tyler—who is of Saxon descent in the novel—represents the British working classes. Egan’s Tyler attempts to obtain the end of serfdom for the Anglo-Saxons (which means enfranchisement "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("for the nineteenth century working classes) through ‘petitions’ but to no avail. Tyler then leads a peasants’ revolt in order to obtain ‘a code of laws or charter’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_63",
      "id": "ch02_63"
    }
  }, [_vm._v("63")])]), _vm._v(" Egan’s retelling of the revolt is largely faithful to the historical record, with the exception that Tyler is conveyed to his home after the events at Smithfield and there dies in his bed.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f019-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Pierce Egan the Younger and illustrations from his epic novel "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wat Tyler: The Rebellion of 1381")]), _vm._v(". (Stephen Basdeo’s Personal Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tyler was a great source of inspiration to the Chartists. His name was invoked in order to inspire activists to never lose hope in the great work they were trying to achieve. An oft-reprinted Chartist poem titled ‘A Song for the Next Rebellion’, which first appeared in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Odd Fellow")]), _vm._v(" in 1841 and made successive appearances in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Northern Star")]), _vm._v(" and other Chartist publications, depicted Tyler as the first in a long line of brave revolutionaries whose legacy was being continued by themselves:")]), _vm._v(" "), _c('div', {
    staticClass: "blockq"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Up! Up! Ye English peasantry, for whom Wat Tyler bled;")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Up! Citied serfs, whose sturdy sires Cade and Archamber led;")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Up! Up! For equal rights and laws: your cause is all as good")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As when in the presence of the Smith a traitor monarch stood."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_64",
      "id": "ch02_64"
    }
  }, [_vm._v("64")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("Previous rebels such as Tyler, Cade, and Archamber may have failed, but victory is sure to belong to the ‘citied serfs’—the factory workers, the seamstresses, the coal miners. The poem continued:")]), _vm._v(" "), _c('div', {
    staticClass: "blockq"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Up! Up! If ye are Englishmen; be mindful of the day,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When Cromwell strode o’er Worcester’s fields, and scared a King away.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Though Cade and Ket and Tyler failed, the ‘crowning mercy’ came: -")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hurrah for England’s stalwart one! Your fortune be the same!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("[…]")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Up! Up! Ye toil-worn English slaves: if blood must needs be shed,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Let it be England’s tyrant lords, and not the famine-sped!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ay, hand-to-hand, and foot to foot, grapple with tyranny! –")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Our Saxon Thor is Lord again: Our England shall be free!"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ach02_65",
      "id": "ch02_65"
    }
  }, [_vm._v("65")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("To the Chartists, Tyler was ‘Our Saxon Thor’—a semi-godlike revolutionary—indicative of the high esteem in which they held his memory. Of course, the aims of the Chartists would not be realised. In spite of three successive petitions, open-air mass meetings, and support from some MPs and high profile journalists like G.W.M. Reynolds (1814–79) the government ignored their demands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, although the movement failed, all but one of the Chartists’ demands were implemented—annual elections being deemed too impractical. In 1867, the right to vote was extended to the ‘respectable’ working class. In 1918, the franchise was extended further to all men and some women, while in 1928, all women were granted the right to vote. During this time, famous socialist activists like William Morris became the custodians, if you will, of Tyler’s memory. Morris’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Dream of John Ball")]), _vm._v(" (1886) depicted the Peasants’ Revolt as the precursor to the emergence of socialism in England.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thus, Tyler’s name could inspire hope and provide historical legitimacy to their political actions in the present. Many of the reformers and revolutionaries featured in this book looked back to Tyler for inspiration. Even within the living memory of many today, during the Poll Tax Riots at Trafalgar Square in the 1980s, people carried placards bearing the words: ‘Avenge Wat Tyler’.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_1",
      "id": "ach02_1"
    }
  }, [_vm._v("1")]), _vm._v(". An early version of this chapter, which has been significantly expanded upon here, has been published in a previous book of mine: Stephen Basdeo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Life and Legend of a Rebel Leader: Wat Tyler")]), _vm._v(" (Barnsley: Pen and Sword, 2018). For this, I would like to thank Barnaby Blacker, who proofread the original chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_2",
      "id": "ach02_2"
    }
  }, [_vm._v("2")]), _vm._v(". John Gower, “John Gower Foresees the Peasants’ Revolt,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Peasants’ Revolt of 1381")]), _vm._v(", ed. R.B. Dobson (London: MacMillan, 1970), 95-96.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_3",
      "id": "ach02_3"
    }
  }, [_vm._v("3")]), _vm._v(". Rosamond Faith, “The ‘Great Rumour’ of 1377 and Peasant Ideology,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The English Rising of 1381")]), _vm._v(", ed. Rodney Hilton and T.H. Alton (Cambridge: Cambridge University Press, 1987), 43–73.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_4",
      "id": "ach02_4"
    }
  }, [_vm._v("4")]), _vm._v(". R. B. Dobson, “Introduction to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anonimalle Chronicle")]), _vm._v(",” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Peasants’ Revolt of 1381")]), _vm._v(", ed. R.B. Dobson (London: MacMillan, 1970), 123.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_5",
      "id": "ach02_5"
    }
  }, [_vm._v("5")]), _vm._v(". Thomas Walsingham, “The Outbreak of the Revolt according to Thomas Walsingham,” in Dobson, 132.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_6",
      "id": "ach02_6"
    }
  }, [_vm._v("6")]), _vm._v(". Ole J. Benedictow, “The Black Death: The Greatest Catastrophe Ever,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History Today")]), _vm._v(" March 3, 2005. Accessed February 23, 2020. "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://www.historytoday.com/archive/black-death-greatest-catastrophe-ever",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.historytoday.com/archive/black-death-greatest-catastrophe-ever")])])])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_7",
      "id": "ach02_7"
    }
  }, [_vm._v("7")]), _vm._v(". Giovanni Boccaccio, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Decameron")]), _vm._v(", M. Rigg, trans. vol. 1 (London: David Campbell, 1921), 5-11")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_8",
      "id": "ach02_8"
    }
  }, [_vm._v("8")]), _vm._v(". C.J. Duncan and S. Scott, “What Caused the Black Death?” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Postgraduate Medical Journal")]), _vm._v(" no. 81 (2005): 315–20: The traditional interpretation, of course, is that the Black Death was a variant of Yersinia pestis. However, new theories have been advanced in the twenty-first century which offer differing explanations of what the disease was. Samuel Klein Cohn in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Black Death Transformed")]), _vm._v(" (2002) argued that the disease was not, in fact, caused by a strain of the aforementioned bacteria, although Cohn never offered an alternative to Yersinia pestis. However, since Cohn, there is some speculation from some scientists like Scott and Duncan that the Black Death was not Bubonic Plague, as is often assumed, but was actually related to the Ebola virus.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_9",
      "id": "ach02_9"
    }
  }, [_vm._v("9")]), _vm._v(". Suzanne Austin Alchon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Pest in the Land: New World Epidemics in a Global Perspective")]), _vm._v(" (Albuquerque: University of New Mexico Press, 2003), 21.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_10",
      "id": "ach02_10"
    }
  }, [_vm._v("10")]), _vm._v(". Rodney Hilton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The English Peasantry of the Later Middle Ages")]), _vm._v(" (Oxford: Clarendon Press, 1975), 13.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_11",
      "id": "ach02_11"
    }
  }, [_vm._v("11")]), _vm._v(". Christopher Dyer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("An Age of Transition? Economy and Society in England in the Later Middle Ages")]), _vm._v(" (Oxford: Clarendon Press, 2005), 34.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_12",
      "id": "ach02_12"
    }
  }, [_vm._v("12")]), _vm._v(". Knighton, “The Black Death of 1348-1329,” 61.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_13",
      "id": "ach02_13"
    }
  }, [_vm._v("13")]), _vm._v(". “The Statute of Labourers,” in Dobson, 64.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_14",
      "id": "ach02_14"
    }
  }, [_vm._v("14")]), _vm._v(". R. B. Dobson, “The Enforcement of the Statute of Labourers,” in Dobson, 68.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_15",
      "id": "ach02_15"
    }
  }, [_vm._v("15")]), _vm._v(". A.E. Levett, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Studies in Manorial History")]), _vm._v(" (Oxford: Oxford University Press, 1938), 134.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_16",
      "id": "ach02_16"
    }
  }, [_vm._v("16")]), _vm._v(". John Ball, “On the Times,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Medieval English Political Writings")]), _vm._v(" ed. James M. Dean (Kalamazoo, MI: Medieval Institute Publications, 1996), 141. Middle English is translated by me.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_17",
      "id": "ach02_17"
    }
  }, [_vm._v("17")]), _vm._v(". Jean Froissart, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chronicles")]), _vm._v(", Geoffrey Brereton, trans. (London: Penguin, 1968), 212.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_18",
      "id": "ach02_18"
    }
  }, [_vm._v("18")]), _vm._v(". Margaret Aston, “Corpus Christi and Corpus Regni: Heresy and the Peasants’ Revolt,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Past & Present")]), _vm._v(" 143 (1994), 36.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_19",
      "id": "ach02_19"
    }
  }, [_vm._v("19")]), _vm._v(". James Simpson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Piers Plowman: An Introduction")]), _vm._v(", 2nd ed. (Exeter: University of Exeter Press, 2007), 38–44; Mary Carruthers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Search for St. Truth: A Study of Meaning in Piers Plowman")]), _vm._v(" (Evanston, IL: Northwestern University Press, 1973), 167.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_20",
      "id": "ach02_20"
    }
  }, [_vm._v("20")]), _vm._v(". Cited in Juliet Barker, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("England Arise: The People, the King, and the Great Revolt of 1381")]), _vm._v(" (London: Abacus, 2014), 428.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_21",
      "id": "ach02_21"
    }
  }, [_vm._v("21")]), _vm._v(". L. J. Andrew Villalon & Donald J. Kagay, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Hundred Years War: a Wider Focus")]), _vm._v(" (Leiden: Brill, 2005), 36.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_22",
      "id": "ach02_22"
    }
  }, [_vm._v("22")]), _vm._v(". Dan Jones, “The Peasants’ Revolt,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History Today")]), _vm._v(" June 2009, 34.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_23",
      "id": "ach02_23"
    }
  }, [_vm._v("23")]), _vm._v(". Dobson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Peasants’ Revolt of 1381")]), _vm._v(", 111")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_24",
      "id": "ach02_24"
    }
  }, [_vm._v("24")]), _vm._v(". Tithe, Constable and Various accounts, 1379-1782. [Microfilm]. Salt Lake City, Utah, Genealogical Society of Utah, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_25",
      "id": "ach02_25"
    }
  }, [_vm._v("25")]), _vm._v(". Carolyn C. Fenwick, “Introduction,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Poll Taxes of 1377, 1379, and 1381 Part 1: Bedfordshire")]), _vm._v(" (Oxford: Oxford University Press, 1998), xxvi.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_26",
      "id": "ach02_26"
    }
  }, [_vm._v("26")]), _vm._v(". Fenwick, “Introduction,” xxvi.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_27",
      "id": "ach02_27"
    }
  }, [_vm._v("27")]), _vm._v(". Christian Drummond Liddy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("War, Politics and Finance in Late Medieval English Towns: Bristol, York and the Crown, 1350–1400")]), _vm._v(" (Woodbridge: Boydell, 2005), 93.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_28",
      "id": "ach02_28"
    }
  }, [_vm._v("28")]), _vm._v(". Barker, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("England Arise")]), _vm._v(", 32.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_29",
      "id": "ach02_29"
    }
  }, [_vm._v("29")]), _vm._v(". Steven Justice, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Writing and Rebellion: England in 1381")]), _vm._v(" (Berkeley and Los Angeles: University of California Press, 1994), 29.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_30",
      "id": "ach02_30"
    }
  }, [_vm._v("30")]), _vm._v(". “The Outbreak of the Revolt according to the “Anonimalle Chronicle,” in Dobson, 127.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_31",
      "id": "ach02_31"
    }
  }, [_vm._v("31")]), _vm._v(". Ibid, 127n: although the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anonimalle Chronicle")]), _vm._v(" says that Burley was present and took an active part in arresting Belling, he was actually away in France negotiating Richard II’s marriage with Anne of Bohemia.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_32",
      "id": "ach02_32"
    }
  }, [_vm._v("32")]), _vm._v(". Anon, “London and its Environs Described (1761),” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Project Gutenberg")]), _vm._v(", accessed April 2, 2020, "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.projectgutenberg.org",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.projectgutenberg.org")])])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_33",
      "id": "ach02_33"
    }
  }, [_vm._v("33")]), _vm._v(". Sylvia Federico, “The Imaginary Society: Women in 1381,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of British Studies")]), _vm._v(" 40 no. 2 (2001): 159–83.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_34",
      "id": "ach02_34"
    }
  }, [_vm._v("34")]), _vm._v(". Federico, 167.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_35",
      "id": "ach02_35"
    }
  }, [_vm._v("35")]), _vm._v(". ‘The Outbreak of the Revolt according to the “Anonimalle Chronicle”’ in Dobson, 127-128.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_36",
      "id": "ach02_36"
    }
  }, [_vm._v("36")]), _vm._v(". Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_37",
      "id": "ach02_37"
    }
  }, [_vm._v("37")]), _vm._v(". Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_38",
      "id": "ach02_38"
    }
  }, [_vm._v("38")]), _vm._v(". Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_39",
      "id": "ach02_39"
    }
  }, [_vm._v("39")]), _vm._v(". Jean Froissart, “Wat Tyler’s Rebellion,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Harvard Classics: Chronicle and Romance – Froissart, Malory, Holinshead. With Introductions, Notes, and Illustrations")]), _vm._v(" ed. by Charles W. Elliot (New York: Collier, 1910) [Internet <"), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://www.gutenberg.org/files/13674/13674-h/13674-h.htm",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.gutenberg.org/files/13674/13674-h/13674-h.htm")])])]), _vm._v("> Accessed 27 March 2017].")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_40",
      "id": "ach02_40"
    }
  }, [_vm._v("40")]), _vm._v(". Thomas Walsingham, “John Ball’s Sermon Theme,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Medieval English Political Writings")]), _vm._v(" ed. by James M. Dean (Kalamazoo, MI: Medieval Institute Publications, 1996), 140.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_41",
      "id": "ach02_41"
    }
  }, [_vm._v("41")]), _vm._v(". Justice, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Writing and Rebellion")]), _vm._v(", 44.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_42",
      "id": "ach02_42"
    }
  }, [_vm._v("42")]), _vm._v(". Jean Froissart, “The Rebels in London according to Froissart,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Peasants’ Revolt of 1381")]), _vm._v(" ed. by R. B. Dobson (London: MacMillan, 1970), 188.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_43",
      "id": "ach02_43"
    }
  }, [_vm._v("43")]), _vm._v(". Helen Nicholson, “The Hospitallers and the “Peasants’ Revolt” of 1381 Revisited,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Military Orders Volume 3: History and Heritage")]), _vm._v(" ed. Victor Mallia Milanes (Aldershot: Ashgate, 2007), 225.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_44",
      "id": "ach02_44"
    }
  }, [_vm._v("44")]), _vm._v(". Froissart, “The Rebels in London according to Froissart,” 189: it is also said at this point that Wat Tyler had a former master of his, one Richard Lyon, killed. That Lyon was killed is evident in other accounts. However, his being a former master of Wat Tyler’s is attested by no other source but Froissart’s.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_45",
      "id": "ach02_45"
    }
  }, [_vm._v("45")]), _vm._v(". Federico, 165.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_46",
      "id": "ach02_46"
    }
  }, [_vm._v("46")]), _vm._v(". Ibid, 168.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_47",
      "id": "ach02_47"
    }
  }, [_vm._v("47")]), _vm._v(". Henry Knighton, “The Rebels in London according to Henry Knighton,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Peasants’ Revolt of 1381")]), _vm._v(" ed. R. B. Dobson (London: MacMillan, 1970), 185.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_48",
      "id": "ach02_48"
    }
  }, [_vm._v("48")]), _vm._v(". Knighton, “The Rebels in London according to Henry Knighton,” 183.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_49",
      "id": "ach02_49"
    }
  }, [_vm._v("49")]), _vm._v(". Gilbert á Beckett, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Comic History of England")]), _vm._v(" (London: John Dicks [n.d.]), 112.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_50",
      "id": "ach02_50"
    }
  }, [_vm._v("50")]), _vm._v(". Froissart, ‘The Rebels in London according to Froissart’ in Dobson, 195.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_51",
      "id": "ach02_51"
    }
  }, [_vm._v("51")]), _vm._v(". ‘The Peasants’ Revolt according to the Continuator of the “Eulogium Historiarum”’, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Peasants’ Revolt of 1381")]), _vm._v(" ed. by R. B. Dobson (London: MacMillan, 1970), 207.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_52",
      "id": "ach02_52"
    }
  }, [_vm._v("52")]), _vm._v(". Froissart, “The Rebels in London according to Froissart,” 196.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_53",
      "id": "ach02_53"
    }
  }, [_vm._v("53")]), _vm._v(". Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_54",
      "id": "ach02_54"
    }
  }, [_vm._v("54")]), _vm._v(". Thomas James Benningfield, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("London, 1900–1964: Armorial Bearings and Regalia of the London County Council, the Corporation of London and the Metropolitan Boroughs")]), _vm._v(" (London: J Burrow & Co., 1964). pp. 21-23; throughout the early modern and modern periods, the dagger on the coat of arms of the city of London was said to commemorate the stabbing of Wat Tyler. However, research has shown that the arms were in use before 1381.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_55",
      "id": "ach02_55"
    }
  }, [_vm._v("55")]), _vm._v(". Froissart, “The Rebels in London according to Froissart,” in Dobson 196.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_56",
      "id": "ach02_56"
    }
  }, [_vm._v("56")]), _vm._v(". Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_57",
      "id": "ach02_57"
    }
  }, [_vm._v("57")]), _vm._v(". Translations of this supposed last dying speech can be found in any one of the following works: Dobson, The Peasants’ Revolt of 1381, 365-66; David Preest and James G. Clark, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Chronica Maiora of Thomas Walsingham")]), _vm._v(" (Woodbridge: Boydell, 2005); H. T. Riley, ed., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chronica Monasterii S. Albani: Thomae Walsingham, Quondam Monachi S. Albani, Historia Anglicana")]), _vm._v(", London Rolls Series, 2 vols (London: Longman, 1872), I: x; Ralph Holinshed, et al., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Chronicles of England")]), _vm._v(", 4 vols (London: Lucas Harrison, 1577), IV, 1036; John Stow, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Summarie of the Chronicles of England")]), _vm._v(" (London: Richard Bradocke, 1598), 149; Ferguson, Robert, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The History of All the Mobs, Tumults, and Insurrections in Great Britain")]), _vm._v(" (London: J. Moore, 1715)")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_58",
      "id": "ach02_58"
    }
  }, [_vm._v("58")]), _vm._v(". Anthony Tuck, ‘Richard II (1367–1400)’, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Oxford Dictionary of National Biography")]), _vm._v(" (Oxford: Oxford University Press, 2004; Online Edn. 2008) [Internet <"), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.oxforddnb.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.oxforddnb.com")])])]), _vm._v("> Accessed 12 March 2017].")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_59",
      "id": "ach02_59"
    }
  }, [_vm._v("59")]), _vm._v(". A complete history of Wat Tyler’s post-medieval portrayals in popular culture is given in my book, cited above.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_60",
      "id": "ach02_60"
    }
  }, [_vm._v("60")]), _vm._v(". Thomas Paine, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Common Sense")]), _vm._v(" (London, 1776), 112")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_61",
      "id": "ach02_61"
    }
  }, [_vm._v("61")]), _vm._v(". Robert Southey, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wat Tyler: A Dramatic Poem in Three Acts")]), _vm._v(" (London: Sherwin, 1813), 10-11")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_62",
      "id": "ach02_62"
    }
  }, [_vm._v("62")]), _vm._v(". See Stephen Basdeo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Robin Hood: The Life and Legend of an Outlaw")]), _vm._v(" (Barnsley: Pen and Sword, 2019)")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_63",
      "id": "ach02_63"
    }
  }, [_vm._v("63")]), _vm._v(". Pierce Egan"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(", Wat Tyler, or, The Rebellion of 1381")]), _vm._v(" (London: G. Pierce, 1847), 835")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_64",
      "id": "ach02_64"
    }
  }, [_vm._v("64")]), _vm._v(". “Hymns for the Unenfranchised: A Song for the Next Rebellion”, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Odd Fellow")]), _vm._v(" 21 August 1841, 3.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02_65",
      "id": "ach02_65"
    }
  }, [_vm._v("65")]), _vm._v(". Ibid.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-057d52d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter01.vue
// module id = 81
// module chunks = 0